import React, { Component } from 'react'
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import MessagesItem from '../../../components/SiteAdmin/ChatMessages/MessagesItem';
import Loader from '../../../components/Common/Loader/Loader';
import NotFound from '../../../components/NotFound/NotFound';

import messages from '../../../locale/messages';
import getAllThreadItemsQuery from './getAllThreadItems.graphql';
import getMoreThreads from './getMoreThreads.graphql';
import { withQuery } from '../../../hoc/withGraphql';


export class ChatMessage extends Component {

	constructor(props) {
		super(props);
		this.loadMore = this.loadMore.bind(this);
	}
	loadMore() {
		const { threadItems: { getAllThreadItems, fetchMore }, bookingId } = this.props;
		fetchMore({
			query: getMoreThreads,
			variables: {
				bookingId,
				offset: getAllThreadItems.threadItems.length,
			},
			updateQuery: (previousResult, { fetchMoreResult }) => {
				if (!fetchMoreResult) { return previousResult; }
				return {
					getAllThreadItems: {
						...previousResult.getAllThreadItems,
						threadItems: [...previousResult.getAllThreadItems.threadItems, ...fetchMoreResult.getMoreThreads],
					},
				};
			},
		});
	}

	render() {
		const { formatMessage } = this.props.intl;
		const { threadItems, from, threadItems: { loading, getAllThreadItems } } = this.props;

		if (!loading && !getAllThreadItems) {
			return <NotFound title={formatMessage(messages.pageNotFound)} />;
		} else {
			return (
				<Loader type={"page"} show={loading}>
					<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.chatMessageLabel)}</h1>
					{!loading && <MessagesItem threadItems={threadItems} from={from} loadMore={this.loadMore} />}
				</Loader>
			)
		}
	}
}

export default compose(
	injectIntl,
	withQuery(getAllThreadItemsQuery, {
		name: 'threadItems',
		options: (props) => ({
			variables: {
				offset: 0,
				bookingId: props.bookingId
			},
			fetchPolicy: 'network-only',
			ssr: false
		})
	})
)(ChatMessage);